import api from "./api";

const create = (data) => {
  return api.post("/api/wo-form-template", data);
};

const getAll = (isActive, formType, customerId) => {
  const params = {};
  if (isActive !== undefined && isActive !== "") params.isActive = isActive;
  if (formType !== undefined && formType !== "") params.formType = formType;
  if (customerId !== undefined && customerId !== null && customerId !== "") params.customerId = customerId;
  return api.get("/api/wo-form-template", { params });
};

const getById = (id) => {
  return api.get(`/api/wo-form-template/${id}`);
};

const update = (id, data) => {
  return api.patch(`/api/wo-form-template/${id}`, data);
};

const archive = (id) => {
  return api.patch(`/api/wo-form-template/${id}/archive`);
};

const restore = (id) => {
  return api.patch(`/api/wo-form-template/${id}/restore`);
};

const remove = (id) => {
  return api.delete(`/api/wo-form-template/${id}`);
};

const FormTemplateService = {
  create,
  getAll,
  getById,
  update,
  archive,
  restore,
  remove,
};

export default FormTemplateService;
